import {useEffect, useState} from "react";
import {DateTime} from "luxon";

export const useTime = (refreshCycle = 100) => {
	const [now, setNow] = useState(getTime());

	useEffect(() => {
		const intervalId = setInterval(() => setNow(getTime()), refreshCycle);

		return () => clearInterval(intervalId);
	}, [refreshCycle, setNow]);

	return now;
};

export const getTime = () => {
	return DateTime.local();
};

export const useCountDownTimer = (end: string) => {
	const now = useTime(500);
	const diff = DateTime.fromISO(end).diff(now);

	if (diff.milliseconds < 0) {
		return now.diff(now);
	}

	return diff;
};

export const useCountUpTimer = (start: string) => {
	const now = useTime(500);
	const diff = now.diff(DateTime.fromISO(start));

	if (diff.milliseconds < 0) {
		return now.diff(now);
	}

	return diff;
};
